module.exports = __webpack_public_path__ + "static/fonts/Fredoka-Regular.a2ba9e3.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fredoka/Fredoka-Regular.ttf
// module id = 190
// module chunks = 23